// import React, { useEffect, useState } from 'react';
// import { fetchUsers, createUser, deleteUser } from '../services/api';
// import APIKeyManager from '../components/APIKeyManager';

// export default function AdminPage() {
//     const [activeTab, setActiveTab] = useState('users');
//     const [users, setUsers] = useState([]);
//     const [newUser, setNewUser] = useState({ username: '', password: '', role: 'viewer' });
//     const [error, setError] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);

//     useEffect(() => {
//         if (activeTab === 'users') {
//             loadUsers();
//         }
//     }, [activeTab]);

//     const loadUsers = async () => {
//         try {
//             setLoading(true);
//             const res = await fetchUsers();
//             setUsers(res.data);
//             setError('');
//         } catch (err) {
//             console.error('Error loading users:', err);
//             setError('Failed to load users');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleCreateUser = async () => {
//         if (!newUser.username || !newUser.password) {
//             setError('Username and password are required');
//             return;
//         }

//         try {
//             await createUser(newUser.username, newUser.password, newUser.role);
//             setNewUser({ username: '', password: '', role: 'viewer' });
//             loadUsers();
//             setError('');
//         } catch (err) {
//             setError('Failed to create user');
//         }
//     };

//     const handleDeleteUser = async (id) => {
//         if (window.confirm('Are you sure you want to delete this user?')) {
//             try {
//                 await deleteUser(id);
//                 loadUsers();
//             } catch (err) {
//                 setError('Failed to delete user');
//             }
//         }
//     };

//     return (
//         <div className="space-y-6">
//             {/* Tab Navigation */}
//             <div className="bg-white shadow">
//                 <div className="px-4 sm:px-6 lg:px-8">
//                     <div className="border-b border-gray-200">
//                         <nav className="-mb-px flex space-x-8">
//                             <button
//                                 onClick={() => setActiveTab('users')}
//                                 className={`py-2 px-1 border-b-2 font-medium text-sm ${
//                                     activeTab === 'users'
//                                         ? 'border-blue-500 text-blue-600'
//                                         : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//                                 }`}
//                             >
//                                 <div className="flex items-center">
//                                     <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
//                                     </svg>
//                                     User Management
//                                 </div>
//                             </button>
//                             <button
//                                 onClick={() => setActiveTab('api-keys')}
//                                 className={`py-2 px-1 border-b-2 font-medium text-sm ${
//                                     activeTab === 'api-keys'
//                                         ? 'border-blue-500 text-blue-600'
//                                         : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//                                 }`}
//                             >
//                                 <div className="flex items-center">
//                                     <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
//                                     </svg>
//                                     API Keys
//                                 </div>
//                             </button>
//                         </nav>
//                     </div>
//                 </div>
//             </div>

//             {/* Content based on active tab */}
//             {activeTab === 'users' ? (
//                 <>
//                     {/* User Management Header */}
//                     <div className="bg-white shadow sm:rounded-lg">
//                         <div className="px-4 py-5 sm:p-6">
//                             <h3 className="text-lg leading-6 font-medium text-gray-900">
//                                 User Management
//                             </h3>
//                             <p className="mt-1 text-sm text-gray-500">
//                                 Create and manage user accounts for the internal platform
//                             </p>
//                         </div>
//                     </div>

//                     {/* Error Alert */}
//                     {error && (
//                         <div className="rounded-md bg-red-50 p-4">
//                             <div className="flex">
//                                 <div className="ml-3">
//                                     <h3 className="text-sm font-medium text-red-800">{error}</h3>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {/* Create User Form */}
//                     <div className="bg-white shadow sm:rounded-lg">
//                         <div className="px-4 py-5 sm:p-6">
//                             <h3 className="text-base font-semibold leading-6 text-gray-900 mb-4">
//                                 Create New User
//                             </h3>
//                             <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
//                                 <input
//                                     type="text"
//                                     placeholder="Username"
//                                     className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
//                                     value={newUser.username}
//                                     onChange={e => setNewUser({ ...newUser, username: e.target.value })}
//                                 />
//                                 <div className="relative">
//                                     <input
//                                         type={showPassword ? "text" : "password"}
//                                         placeholder="Password"
//                                         className="block w-full pr-10 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
//                                         value={newUser.password}
//                                         onChange={e => setNewUser({ ...newUser, password: e.target.value })}
//                                     />
//                                     <button
//                                         type="button"
//                                         className="absolute inset-y-0 right-0 pr-3 flex items-center"
//                                         onClick={() => setShowPassword(!showPassword)}
//                                     >
//                                         {showPassword ? (
//                                             <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//                                             </svg>
//                                         ) : (
//                                             <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                                             </svg>
//                                         )}
//                                     </button>
//                                 </div>
//                                 <select
//                                     className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
//                                     value={newUser.role}
//                                     onChange={e => setNewUser({ ...newUser, role: e.target.value })}
//                                 >
//                                     <option value="viewer">Viewer</option>
//                                     <option value="developer">Developer</option>
//                                     <option value="admin">Admin</option>
//                                 </select>
//                                 <button
//                                     onClick={handleCreateUser}
//                                     className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//                                 >
//                                     Create User
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Users Table */}
//                     <div className="bg-white shadow overflow-hidden sm:rounded-lg">
//                         <table className="min-w-full divide-y divide-gray-200">
//                             <thead className="bg-gray-50">
//                                 <tr>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                         ID
//                                     </th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                         Username
//                                     </th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                         Role
//                                     </th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                         Actions
//                                     </th>
//                                 </tr>
//                             </thead>
//                             <tbody className="bg-white divide-y divide-gray-200">
//                                 {loading ? (
//                                     <tr>
//                                         <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
//                                             Loading users...
//                                         </td>
//                                     </tr>
//                                 ) : users.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
//                                             No users found
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     users.map(user => (
//                                         <tr key={user.id}>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                                                 {user.id}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                                                 {user.username}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 <span className={`inline-flex px-2 text-xs font-semibold rounded-full ${
//                                                     user.role === 'admin'
//                                                         ? 'bg-red-100 text-red-800'
//                                                         : user.role === 'developer'
//                                                         ? 'bg-blue-100 text-blue-800'
//                                                         : 'bg-gray-100 text-gray-800'
//                                                 }`}>
//                                                     {user.role}
//                                                 </span>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                                                 <button
//                                                     onClick={() => handleDeleteUser(user.id)}
//                                                     className="text-red-600 hover:text-red-900"
//                                                 >
//                                                     Delete
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </>
//             ) : (
//                 <APIKeyManager isAdmin={true} />
//             )}
//         </div>
//     );
// }

// AdminPage.jsx - Updated with Security Scanner Tab

import React, { useEffect, useState } from 'react';
import { fetchUsers, createUser, deleteUser } from '../services/api';
import APIKeyManager from '../components/APIKeyManager';
import SecurityDashboard from '../components/SecurityDashboard';

export default function AdminPage() {
    const [activeTab, setActiveTab] = useState('users');
    const [users, setUsers] = useState([]);
    const [newUser, setNewUser] = useState({ username: '', password: '', role: 'viewer' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (activeTab === 'users') {
            loadUsers();
        }
    }, [activeTab]);

    const loadUsers = async () => {
        try {
            setLoading(true);
            const res = await fetchUsers();
            setUsers(res.data);
            setError('');
        } catch (err) {
            console.error('Error loading users:', err);
            setError('Failed to load users');
        } finally {
            setLoading(false);
        }
    };

    const handleCreateUser = async () => {
        if (!newUser.username || !newUser.password) {
            setError('Username and password are required');
            return;
        }

        try {
            await createUser(newUser.username, newUser.password, newUser.role);
            setNewUser({ username: '', password: '', role: 'viewer' });
            loadUsers();
            setError('');
        } catch (err) {
            setError('Failed to create user');
        }
    };

    const handleDeleteUser = async (id) => {
        if (window.confirm('Are you sure you want to delete this user?')) {
            try {
                await deleteUser(id);
                loadUsers();
            } catch (err) {
                setError('Failed to delete user');
            }
        }
    };

    return (
        <div className="space-y-6">
            {/* Tab Navigation */}
            <div className="bg-white shadow">
                <div className="px-4 sm:px-6 lg:px-8">
                    <div className="border-b border-gray-200">
                        <nav className="-mb-px flex space-x-8">
                            <button
                                onClick={() => setActiveTab('users')}
                                className={`py-2 px-1 border-b-2 font-medium text-sm ${
                                    activeTab === 'users'
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                            >
                                <div className="flex items-center">
                                    <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                    </svg>
                                    User Management
                                </div>
                            </button>
                            <button
                                onClick={() => setActiveTab('api-keys')}
                                className={`py-2 px-1 border-b-2 font-medium text-sm ${
                                    activeTab === 'api-keys'
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                            >
                                <div className="flex items-center">
                                    <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                    </svg>
                                    API Keys
                                </div>
                            </button>
                            <button
                                onClick={() => setActiveTab('security')}
                                className={`py-2 px-1 border-b-2 font-medium text-sm ${
                                    activeTab === 'security'
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                            >
                                <div className="flex items-center">
                                    <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                    </svg>
                                    Security Scanner
                                </div>
                            </button>
                        </nav>
                    </div>
                </div>
            </div>

            {/* Content based on active tab */}
            {activeTab === 'users' ? (
                <>
                    {/* User Management Header */}
                    <div className="bg-white shadow sm:rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <h3 className="text-lg leading-6 font-medium text-gray-900">
                                User Management
                            </h3>
                            <p className="mt-1 text-sm text-gray-500">
                                Create and manage user accounts for the internal platform
                            </p>
                        </div>
                    </div>

                    {/* Error Alert */}
                    {error && (
                        <div className="rounded-md bg-red-50 p-4">
                            <div className="flex">
                                <div className="ml-3">
                                    <h3 className="text-sm font-medium text-red-800">{error}</h3>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Create User Form */}
                    <div className="bg-white shadow sm:rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <h3 className="text-base font-semibold leading-6 text-gray-900 mb-4">
                                Create New User
                            </h3>
                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
                                <input
                                    type="text"
                                    placeholder="Username"
                                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    value={newUser.username}
                                    onChange={e => setNewUser({ ...newUser, username: e.target.value })}
                                />
                                <div className="relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Password"
                                        className="block w-full pr-10 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                        value={newUser.password}
                                        onChange={e => setNewUser({ ...newUser, password: e.target.value })}
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? (
                                            <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                            </svg>
                                        ) : (
                                            <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                                <select
                                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    value={newUser.role}
                                    onChange={e => setNewUser({ ...newUser, role: e.target.value })}
                                >
                                    <option value="viewer">Viewer</option>
                                    <option value="developer">Developer</option>
                                    <option value="admin">Admin</option>
                                </select>
                                <button
                                    onClick={handleCreateUser}
                                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    Create User
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Users Table */}
                    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        ID
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Username
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Role
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {loading ? (
                                    <tr>
                                        <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
                                            Loading users...
                                        </td>
                                    </tr>
                                ) : users.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
                                            No users found
                                        </td>
                                    </tr>
                                ) : (
                                    users.map(user => (
                                        <tr key={user.id}>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {user.id}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                {user.username}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                <span className={`inline-flex px-2 text-xs font-semibold rounded-full ${
                                                    user.role === 'admin'
                                                        ? 'bg-red-100 text-red-800'
                                                        : user.role === 'developer'
                                                        ? 'bg-blue-100 text-blue-800'
                                                        : 'bg-gray-100 text-gray-800'
                                                }`}>
                                                    {user.role}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                <button
                                                    onClick={() => handleDeleteUser(user.id)}
                                                    className="text-red-600 hover:text-red-900"
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : activeTab === 'api-keys' ? (
                <APIKeyManager isAdmin={true} />
            ) : activeTab === 'security' ? (
                <SecurityDashboard />
            ) : null}
        </div>
    );
}